import {
  ADD_ADVERTISEMENT_START,
  ADD_ADVERTISEMENT_ERROR,
  ADD_ADVERTISEMENT_SUCCESS,
} from 'constants/action-types/communication/addAdvertisment';

export default (state, { type, payload }) => {
  switch (type) {
    case ADD_ADVERTISEMENT_START:
      return {
        ...state,
        addAdvertisement: {
          ...state.addAdvertisement,
          loading: true,
          error: null,
        },
      };
    case ADD_ADVERTISEMENT_ERROR:
      return {
        ...state,
        addAdvertisement: {
          ...state.addAdvertisement,
          error: payload,
          loading: false,
        },
      };
    case ADD_ADVERTISEMENT_SUCCESS:
      return {
        ...state,
        addAdvertisement: {
          ...state.addAdvertisement,
          data: payload?.data,
          loading: false,
          error: null,
        },
      };
    default:
      return null;
  }
};
